import React, { useEffect } from "react";
import "./cookieBar.scss";

export const CookieBar = (props: any) => {
    const [showCookieBar, setShowCookieBar] = React.useState<boolean>(true);
    let cookieName = props.cookieName;
    const cookieValue = props.cookieValue;
    let cookiePath = cookieName + "=" + cookieValue;

    useEffect(() => {
        if (document.cookie.split("; ").find((row) => row.startsWith(cookieName))) {
            setShowCookieBar(false);
        }
    }, [cookieName]);

    const setCookie = () => {
        document.cookie = cookiePath + ";path=/";
        setShowCookieBar(false);
    };

    return (
        <>
            {showCookieBar && (
                <div className={"cookie-bar"}>
                    <div>
                        {props.text}&nbsp;
                        <a href={props.privacyLink}>{props.privacyText}</a>
                    </div>
                    <div>
                        <a id={"buttonCookieBar"} className={"cookie-bar-button"} onClick={setCookie}>
                            {props.buttonName}
                        </a>
                    </div>
                </div>
            )}
        </>
    );
};
